import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  InfoCircle,
  ExclamationCircle,
  ExclamationTriangle,
} from 'react-bootstrap-icons';
import '@styles/common/components/alert.scss';

const propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'danger']),
  message: PropTypes.node.isRequired,
  children: PropTypes.node,
};

const icons = {
  info: <InfoCircle />,
  warning: <ExclamationCircle />,
  danger: <ExclamationTriangle />,
};

const Alert = forwardRef(({
  variant,
  message,
  children,
  className = '',
  ...rest
}, ref) => {
  return (
    <div
      ref={ref}
      className={
        'mic-alert'
        + (variant ? ` mic-alert--${variant}` : '')
        + (className ? ` ${className}` : '')
      }
      {...rest}
    >
      <div className="mic-alert__header">
        {icons[variant] && (
          <span
            aria-hidden="true"
            className="mic-alert__icon"
          >
            {icons[variant]}
          </span>
        )}
        <div
          className="mic-alert__message"
          data-error-message
        >
          {message}
        </div>
      </div>
      {children && <div className="mic-alert__body">{children}</div>}
    </div>
  );
});

Alert.propTypes = propTypes;

export default Alert;
